import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from "@angular/core";
import { CollaboratorInvitation } from "@models/collaborator";
import { Page } from "@models/page";
import { hasInputChanged } from "@shared/helpers/hasChanges/hasChanges.helper";
import { PaginatorState } from "primeng/paginator";
import { SkeletonModule } from "primeng/skeleton";
import { ButtonComponent } from "../../../../../shared/components/button/button.component";
import { CollaboratorInvitationCardComponent } from "./collaborator-invitation-card/collaborator-invitation-card.component";

@Component({
    selector: "app-collaborators-invitations-list",
    imports: [
        SkeletonModule,
        ButtonComponent,
        CollaboratorInvitationCardComponent,
    ],
    templateUrl: "./collaborator-invitations-list.component.html",
    styleUrl: "./collaborator-invitations-list.component.scss"
})
export class CollaboratorInvitationsListComponent implements OnChanges {
  @Input() invitationsPage: Page<CollaboratorInvitation> | null = null;
  @Input() isLoading = false;

  @Output() acceptInvitationClick = new EventEmitter<CollaboratorInvitation>();
  @Output() pageChange = new EventEmitter<PaginatorState>();
  @Output() detailsClick = new EventEmitter<CollaboratorInvitation>();

  invitations: CollaboratorInvitation[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    const hasChanges = hasInputChanged<
      CollaboratorInvitationsListComponent,
      "invitationsPage"
    >(changes, "invitationsPage");
    if (hasChanges) {
      const invitationChanges: SimpleChanges["invitationsPage"] =
        changes["invitationsPage"];

      const newPage = invitationChanges.currentValue?.meta.page;
      const oldPage = invitationChanges.previousValue?.meta.page;

      if (invitationChanges && invitationChanges.currentValue?.data) {
        if (oldPage != null && newPage! > oldPage) {
          this.invitations.push(...invitationChanges.currentValue.data);
        } else {
          this.invitations = [...invitationChanges.currentValue.data];
        }
      }
    }
  }

  loadMoreInvitations() {
    const paginationMeta = this.invitationsPage?.meta;

    if (paginationMeta) {
      const paginatorState: PaginatorState = {
        page: paginationMeta.current_page,
        pageCount: 10,
      };
      this.pageChange.emit(paginatorState);
    }
  }

  handleAcceptClick(invitation: CollaboratorInvitation) {
    this.acceptInvitationClick.emit(invitation);
  }
}
